// @ts-nocheck
import { Component } from '@theme/component';
import { ThemeEvents } from '@theme/events';

/**
 * @typedef {object} Refs
 * @property {HTMLElement} [link]
 * @property {HTMLElement} [guide]
 * @property {HTMLElement} [lensWidth]
 * @property {HTMLElement} [bridgeWidth]
 * @property {HTMLElement} [templeLength]
 * @property {HTMLElement} [modelCode]
 * @property {HTMLElement} [fullMeasurements]
 * @property {HTMLElement} [measureBlock]
 *
 * @extends Component<Refs>
 */
export class SizeGuideComponent extends Component {
  requiredRefs = ['link', 'guide', 'lensWidth', 'bridgeWidth', 'templeLength', 'modelCode', 'fullMeasurements', 'measureBlock'];

  MM_TO_INCH = 0.0393701;
  currentUnit = 'mm'; // default

  connectedCallback() {
    super.connectedCallback();

    this.refs.link?.addEventListener('click', this.#onClickLink);

    // Toggle mm/inch
    const checkboxEl = this.querySelector('.unit-toggle');

    if (checkboxEl instanceof HTMLInputElement) {
      checkboxEl.addEventListener('change', () => {
        this.currentUnit = checkboxEl.checked ? 'inch' : 'mm';
        const unitLabel = this.querySelector('.unit-label');
        if (unitLabel) {
          const mmLabel = checkboxEl.dataset.mm || 'mm';
          const inchLabel = checkboxEl.dataset.inch || 'inch';
          unitLabel.textContent = checkboxEl.checked ? inchLabel : mmLabel;
        }
        this.#updateMeasurements();
      });
    }
    
    // 🔄 Ascolta i cambiamenti di variant
    document.addEventListener(ThemeEvents.variantUpdate, this.#onVariantUpdate);
    
    this.#updateMeasurements();
  }

  disconnectedCallback() {
    super.disconnectedCallback();
    this.refs.link?.removeEventListener('click', this.#onClickLink);
    document.removeEventListener(ThemeEvents.variantUpdate, this.#onVariantUpdate);
  }

  /**
   * @param {MouseEvent} event
   */
  #onClickLink = (event) => {
    event.preventDefault();
    if (this.refs.link) this.refs.link.style.display = 'none';
    this.refs.guide?.removeAttribute('hidden');
    this.#updateMeasurements();
  };

  /**
   * @param {CustomEvent} event
   */
  #onVariantUpdate = (event) => {
    this.#updateMeasurements();
  };

  /**
   * @typedef {Object} SizeGuideValues
   * @property {string} lensWidth
   * @property {string} lensHeight
   * @property {string} bridgeWidth
   * @property {string} templeLength
   * @property {string} modelCode
   * @property {number[]} [_mmValues] 
   */

  /** @typedef {Record<string, SizeGuideValues>} SizeGuideData */
  #updateMeasurements = () => {

    const list = document.querySelector('.pdp-size-list');
    if (!list) return;

    const active = list.querySelector('.pdp-size__item.is-active');
    if (!(active instanceof HTMLElement)) return;

    const variantId = active.dataset.variantId;
    if (!variantId) return;

    const dataScript = document.getElementById('size-guide-data');
    if (!dataScript) return;

    /** @type {SizeGuideData} */
    let data = {};
    try {
      data = JSON.parse(dataScript.textContent || '{}');
    } catch (e) {
      console.error('Size guide JSON invalido', e);
      return;
    }

    const variant = data[variantId];
    if (!variant) return;

    if (!variant._mmValues) {
      variant._mmValues = [
        parseFloat(variant.lensWidth),
        parseFloat(variant.bridgeWidth),
        parseFloat(variant.templeLength),
        parseFloat(variant.lensHeight)
      ];
    }

    /**
     * @typedef {Object} BuildStringOptions
     * @property {number} fieldIndex
     * 
     * @param {number} fieldIndex
     * @returns {string}
     */
    const buildString = (fieldIndex) => {
      if (!variant._mmValues) return '';
      return variant._mmValues
      .map((mmVal, i) => {
        const val = this.currentUnit === 'inch'
        ? (mmVal * this.MM_TO_INCH).toFixed(2)
        : mmVal.toString();
        return i === fieldIndex ? `<strong>${val}</strong>` : val;
      })
      .join(' / ');
    };

    const lensEl = this.querySelector('.measure-block.lens .measure-item');
    const bridgeEl = this.querySelector('.measure-block.bridge .measure-item');
    const templeEl = this.querySelector('.measure-block.temple .measure-item');
    const heightEl = this.querySelector('.measure-block.height .measure-item');

    if (lensEl) lensEl.innerHTML = buildString(0);
    if (bridgeEl) bridgeEl.innerHTML = buildString(1);
    if (templeEl) templeEl.innerHTML = buildString(2);
    if (heightEl) heightEl.innerHTML = buildString(3);

    if (this.refs.lensWidth) this.refs.lensWidth.textContent = this.currentUnit === 'inch'
      ? (parseFloat(variant.lensWidth) * this.MM_TO_INCH).toFixed(2) + '"'
      : variant.lensWidth;

    if (this.refs.bridgeWidth) this.refs.bridgeWidth.textContent = this.currentUnit === 'inch'
      ? (parseFloat(variant.bridgeWidth) * this.MM_TO_INCH).toFixed(2) + '"'
      : variant.bridgeWidth;

    if (this.refs.templeLength) this.refs.templeLength.textContent = this.currentUnit === 'inch'
      ? (parseFloat(variant.templeLength) * this.MM_TO_INCH).toFixed(2) + '"'
      : variant.templeLength;

          if (this.refs.lensWidth) this.refs.lensWidth.textContent = variant.lensWidth;
    if (this.refs.bridgeWidth) this.refs.bridgeWidth.textContent = variant.bridgeWidth;
    if (this.refs.templeLength) this.refs.templeLength.textContent = variant.templeLength;

    if (this.refs.fullMeasurements) {
      const modelCode = this.refs.modelCode?.textContent || '';
      this.refs.fullMeasurements.textContent = `${modelCode}  ${variant.lensWidth}  ${variant.bridgeWidth}  ${variant.templeLength}`;
    }
  };
}

if (!customElements.get('size-guide')) {
  customElements.define('size-guide', SizeGuideComponent);
}